import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { UserEntity } from 'Models/Entities';
import { searchCustomersByNameEmailPhone } from 'Views/Components/_HumanWritten/CustomerSelection/CustomerSelectionUtils';

export const useCustomerSearch = () => {
	const queryClient = useQueryClient();

	const loadOptions = useCallback(
		async (inputValue: string): Promise<UserEntity[]> => {
			// Only search if there is input or if we want default options
			return queryClient.fetchQuery({
				queryKey: ['customer-search', inputValue],
				queryFn: () => searchCustomersByNameEmailPhone(inputValue),
				staleTime: 1000 * 60 * 5, // 5 minutes cache
			});
		},
		[queryClient],
	);

	return { loadOptions };
};

export const useCustomer = (userId?: string) => {
	return useQuery({
		queryKey: ['customer', userId],
		queryFn: async () => {
			if (!userId) return null;
			const results = await searchCustomersByNameEmailPhone('', userId);
			return results.find(x => x.id === userId) || null;
		},
		enabled: !!userId,
		staleTime: 1000 * 60 * 5, // 5 minutes
	});
};
